import SparkMD5 from "spark-md5";

export function calculateMD5(file) {
  return new Promise((resolve, reject) => {
    const spark = new SparkMD5.ArrayBuffer();
    const chunkSize = 512 * 1024; // 分块大小（512KB）
    const chunks = Math.ceil(file.size / chunkSize);
    let currentChunk = 0;
    const fileReader = new FileReader();

    fileReader.onload = e => {
      spark.append(e.target.result); // 增量计算哈希
      currentChunk++;
      if (currentChunk < chunks) {
        loadNextChunk();
      } else {
        resolve(spark.end()); // 返回最终MD5值
      }
    };

    fileReader.onerror = reject;

    function loadNextChunk() {
      const start = currentChunk * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      fileReader.readAsArrayBuffer(file.slice(start, end));
    }

    loadNextChunk();
  });
}



// WEBPACK FOOTER //
// ./src/utils/md5.js